<template>
    <!-- <div>
        <div class="container">
            <div class="visual__btn-wrap">
                <a href="https://edaom.kr/" target="_blank" class="button visual__btn">e다옴</a>
                <a href="https://edaom.kr/support/total" target="_blank" class="button visual__btn">e만듦</a>
                <a href="#" class="button visual__btn">e바꿈</a>
            </div>
            <div class="visual__tit">e이음을 통해 <strong class="color-primary">전자제조 전문기업</strong>과 <br class="d-none d-md-block"/><strong class="color-primary">전문가</strong>를 만나보세요.</div>
        </div>
        <div class="visual__background" style="background-image:url(/images/main/v1.png)"></div>
    </div> -->
    <div v-if="banner && ((pc && isPC) || (mobile && isMobile))" class="main-visual swiper-container">
        <div class="visual__btn-wrap">
            <a href="https://edaom.kr/" target="_blank" class="button visual__btn">e다옴</a>
            <a href="https://edaom.kr/support/total" target="_blank" class="button visual__btn">e만듦</a>
            <a href="#" class="button visual__btn">e바꿈</a>
        </div>
        <div class="swiper-wrapper">
            <div v-for="(slide, index) in banner.slides" :key="index" class="swiper-slide">
                <component :is="dynamicComponent(slide.url)" :to="slide.url" :href="slide.url">
                    <picture>
                        <source :srcset="slide.image" media="(max-width:1200px)" />
                        <img :src="slide.image" alt="" />
                    </picture>
                </component>
            </div>
        </div>
        <div class="main-visual__controls">
            <!-- <div class="main-visual__prev"></div>
            <div class="main-visual__next"></div> -->
            <div class="pagination"></div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
export default {
    props: {
        pc: Boolean,
        mobile: Boolean,
    },
    data() {
        return {
            detect,
            banner: null,
            width: window.innerWidth,
        };
    },
    computed: {
        isPC() {
            return this.width >= 768;
        },
        isMobile() {
            return this.width < 768;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let {banner} = await api.v1.banners.get({code: this.$attrs.code, params: {sites: this.$attrs.sites}});
            this.banner = banner;

            this.$nextTick(() => {
                var mainVisual = new Swiper(".main-visual", {
                    allowTouchMove: false,
                    centeredSlides: true,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 300,
                    loop: true,
                    pagination: {
                        el: ".main-visual .pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".main-visual__next",
                        prevEl: ".main-visual__prev",
                    },
                    breakpoints: {
                        1200: {
                            allowTouchMove: true,
                        },
                    },
                });
            });

            window.addEventListener("resize", this.setWidth);
        },
        dynamicComponent(url) {
            return (url || "").indexOf("/") == 0 ? "router-link" : "a";
        },
        setWidth() {
            this.width = window.innerWidth;
        },
    },
    destroyed(){
        window.removeEventListener("resize", this.setWidth)
    }
};
</script>
